import React, { Component } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { default as CommonButton } from './common/Button';
import { observable, action } from 'mobx';
import Icon from './common/Icon';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  justify-content: center;
  align-content: center;
  width: 100%;
  padding: 3rem 2rem;
`;

const Content = styled.div`
  align-self: center;
  justify-self: center;
  text-align: center;
`;

const Button = styled(CommonButton)`
  margin-top: 2rem;
`;

const TitleIcon = styled(Icon)`
  font-size: 3rem;
  margin-bottom: 2rem;
`;

@observer
export default class InvalidSessionNotice extends Component {
  @observable isRefreshing = false;
  @action setIsRefreshing() {
    this.isRefreshing = true;
  }

  triggerReload = () => {
    if (!this.isRefreshing) {
      this.setIsRefreshing();
      location.reload();
    }
  };

  render() {
    return (
      <Container>
        <Content>
          <TitleIcon name="ban" />
          <div>I'm sorry, it appears your session is invalid.</div>
          <div>Please reload and try again.</div>
          <Button onClick={this.triggerReload} isLoading={this.isRefreshing}>
            {this.isRefreshing ? 'Reloading...' : 'Reload'}
          </Button>
        </Content>
      </Container>
    );
  }
}
